export const BACKGROUND_SCANNER_PREFIX = '@@';
export const BACKGROUND_SCANNER_SUFFIX = '##';
export const BACKGROUND_SCANNER_INFINITY_INTERVAL = 30000; // 30 sek
export const BACKGROUND_SCANNER_BUFFER_MAX_LENGTH = 1000;
